// ===========================================================================
// ProCare.SG — icon registry
// ---------------------------------------------------------------------------
// Content files name their icon as a string ("Truck", "Sparkles"). Resolving
// those through `import * as Icons from "lucide-react"` pulls the entire icon
// set — well over a thousand components — into the main bundle, because a
// namespace import cannot be tree-shaken. Naming each icon explicitly keeps
// only the ones the site actually uses.
//
// Adding a new icon to a data file? Add the matching import here too.
// ===========================================================================
import {
    BadgeCheck,
    Building2,
    Circle,
    ClipboardCheck,
    ClipboardList,
    Droplets,
    Gem,
    Hammer,
    HeartHandshake,
    Home,
    KeyRound,
    PackageOpen,
    PaintRoller,
    Recycle,
    ShieldAlert,
    ShieldCheck,
    Sparkles,
    Tent,
    Truck,
    Users,
    Wind,
    Wrench,
} from "lucide-react";

export const ICON_REGISTRY = {
    BadgeCheck,
    Building2,
    Circle,
    ClipboardCheck,
    ClipboardList,
    Droplets,
    Gem,
    Hammer,
    HeartHandshake,
    Home,
    KeyRound,
    PackageOpen,
    PaintRoller,
    Recycle,
    ShieldAlert,
    ShieldCheck,
    Sparkles,
    Tent,
    Truck,
    Users,
    Wind,
    Wrench,
};

export default function Icon({ name, className }) {
    const Component = ICON_REGISTRY[name];
    if (!Component) {
        // A missing name renders a neutral placeholder rather than nothing, and
        // says so in development so it is caught before it reaches the site.
        if (process.env.NODE_ENV !== "production") {
            console.warn(`[Icon] "${name}" is not in the registry — add it to components/common/Icon.jsx`);
        }
        return <Circle className={className} />;
    }
    return <Component className={className} />;
}
